import { render, staticRenderFns } from "./Editar-Produto.vue?vue&type=template&id=7909cf36&scoped=true&"
import script from "./Editar-Produto.vue?vue&type=script&lang=js&"
export * from "./Editar-Produto.vue?vue&type=script&lang=js&"
import style0 from "./Editar-Produto.vue?vue&type=style&index=0&id=7909cf36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7909cf36",
  null
  
)

export default component.exports